exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".batdetail-detail {\n  text-align: left !important;\n}\n.batdetail {\n  padding: 0 30px;\n  background: #fff;\n}\n.batdetail .batdetail-header {\n  line-height: 80px;\n  border-bottom: 1px dashed #ddd;\n}\n.batdetail .batdetail-header .bat {\n  font-size: 30px;\n  margin-right: 10px;\n}\n.batdetail .batdetail-detail {\n  padding: 30px 0;\n}\n.batdetail .batdetail-detail .batdetail-basic {\n  overflow: hidden;\n}\n.batdetail .batdetail-detail .batdetail-basic .topfive {\n  line-height: 50px;\n  float: left;\n  width: 100%;\n  font-size: 16px;\n}\n.batdetail .batdetail-detail .batdetail-battery {\n  overflow: hidden;\n}\n.batdetail .batdetail-detail .batdetail-battery .batterydata {\n  float: left;\n  font-size: 17px;\n  width: 100%;\n  line-height: 50px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#3296FA"}}!./src/containers/batteryManagement/batterydetail/index.less
// module id = 1583
// module chunks = 0